import { MESSAGE_TYPE } from "./enums.js"
import useUserStore from '../store/userStore.js';

const SILENT_MANAGEMENT_MESSAGE_TYPES = [
    MESSAGE_TYPE.CONFIG_CHANGED,
    MESSAGE_TYPE.ROLE_CHANGED,
    MESSAGE_TYPE.ROLE_PERM_UPDATED,
    MESSAGE_TYPE.GROUP_PERM_CHANGED
]

const TIP_TEMPLATES = {
    'tip.group.invite': '{0}邀请{1}加入了群聊',
    'tip.group.inviteMembers': '{0}邀请成员加入了群聊',
    'tip.group.inviteMore': '{0}邀请{1}等{2}人加入了群聊',
    'tip.group.rtcStart': '{0}发起了通话',
    'tip.group.rtcEnd': '通话结束',
    'tip.group.banned': "群聊因'{0}'被封禁",
    'tip.group.unbanned': '群聊已解封',
    'tip.friend.becameFriend': '你们已成为好友，现在可以开始聊天了',
    'tip.friend.relationRemoved': '你们的好友关系已解除',
    'tip.recall.quote': '引用内容已撤回',
    'tip.recall.self': '{0}撤回了一条消息',
    'tip.recall.byOther': '{0}撤回了{1}的一条消息'
}

function normalizeIdentityText(content) {
    const userStore = useUserStore();
    const currentUserId = userStore && userStore.userInfo ? String(userStore.userInfo.id) : '';
    return String(content || '').replace(/#\{([^:]+):(\d+)\}/g, (match, displayName, userId) => {
        return currentUserId && currentUserId === String(userId) ? '你' : displayName;
    });
}

function formatTipTemplate(template, params) {
    const values = Array.isArray(params) ? params : [];
    return template.replace(/\{(\d+)\}/g, (match, index) => {
        return values[index] === undefined || values[index] === null ? '' : String(values[index]);
    });
}

function resolveTipContent(content) {
    try {
        if (!content || !String(content).trim().startsWith('{')) {
            return String(content || '');
        }
        const obj = JSON.parse(content);
        if (obj && obj.key && TIP_TEMPLATES[obj.key]) {
            return formatTipTemplate(TIP_TEMPLATES[obj.key], obj.params);
        }
    } catch (e) {
        console.log("displayContent error,message:", content, e);
    }
    return String(content || '');
}

function displayContent(content) {
    return normalizeIdentityText(resolveTipContent(content));
}

function displayTipContent(content) {
    return resolveTipContent(content);
}

let previewContent = function (msgInfo) {
    let content = "[暂不支持该消息类型]"
    try {
        if (msgInfo.type == MESSAGE_TYPE.IMAGE) {
            content = "[图片]";
        } else if (msgInfo.type == MESSAGE_TYPE.VIDEO) {
            content = "[视频]";
        } else if (msgInfo.type == MESSAGE_TYPE.FILE) {
            content = "[文件] " + JSON.parse(msgInfo.content).name;
        } else if (msgInfo.type == MESSAGE_TYPE.AUDIO) {
            content = "[语音] " + JSON.parse(msgInfo.content).duration + '"';
        } else if (msgInfo.type == MESSAGE_TYPE.USER_CARD) {
            content = "[个人名片] " + JSON.parse(msgInfo.content).nickName;
        } else if (msgInfo.type == MESSAGE_TYPE.GROUP_CARD) {
            content = "[群名片] " + JSON.parse(msgInfo.content).groupName;
        } else if (msgInfo.type == MESSAGE_TYPE.STICKER) {
            content = "[动画表情] " + JSON.parse(msgInfo.content).name;
        } else if (msgInfo.type == MESSAGE_TYPE.MERGE_FORWARD) {
            content = `[合并转发] 共${JSON.parse(msgInfo.content).messages.length}条消息`;
        } else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VOICE) {
            content = "[语音通话]";
        } else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VIDEO) {
            content = "[视频通话]";
        } else if (msgInfo.type == MESSAGE_TYPE.MESSAGE_EDITED) {
            content = msgInfo.content || "[消息已编辑]";
        } else if (SILENT_MANAGEMENT_MESSAGE_TYPES.includes(msgInfo.type)) {
            content = "";
        } else if (msgInfo.type == MESSAGE_TYPE.GROUP_MEMBER_CHANGED) {
            content = "[群成员已更新]";
        } else if (msgInfo.type == MESSAGE_TYPE.FRIEND_REQ_APPLY) {
            content = "[好友申请]";
        } else if (msgInfo.type == MESSAGE_TYPE.FRIEND_REQ_APPROVE) {
            content = "[好友申请已通过]";
        } else if (msgInfo.type == MESSAGE_TYPE.FRIEND_REQ_REJECT) {
            content = "[好友申请被拒绝]";
        } else if (msgInfo.type == MESSAGE_TYPE.FRIEND_REQ_RECALL) {
            content = "[好友申请已撤回]";
        } else if (msgInfo.type == MESSAGE_TYPE.TIP_TIME) {
            content = "[时间]";
        } else if (msgInfo.type == MESSAGE_TYPE.SYSTEM_MESSAGE) {
            content = msgInfo.title;
        } else if (msgInfo.type == MESSAGE_TYPE.TEXT || msgInfo.type == MESSAGE_TYPE.RECALL) {
            content = msgInfo.content;
        } else if (msgInfo.type == MESSAGE_TYPE.TIP_TEXT) {
            content = displayContent(msgInfo.content);
        }
    } catch (e) {
        console.log("message:", msgInfo, e)
    }
    return content;
}

export {
    previewContent,
    displayContent,
    displayTipContent
}
